import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { GetSiteGQL, UpdateSiteGQL } from '../../graphql/graphql';

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss'],
    standalone: false
})
export class SettingsComponent implements OnInit {
  currentSiteData: any = null;
  siteUrl: string = '';
  siteId: string = '';
  successMessage: string = '';
  errorMessage: string = '';
  loading: boolean = true;

  constructor(
    private route: ActivatedRoute,
    private getSiteGQL: GetSiteGQL,
    private updateSiteGQL: UpdateSiteGQL
  ) {}

  ngOnInit() {
    this.siteUrl = this.route.parent?.snapshot.params['url'] || '';
    this.loadSiteData();
  }

  loadSiteData() {
    if (!this.siteUrl) {
      this.loading = false;
      return;
    }

    this.getSiteGQL.watch({ variables: { url: this.siteUrl, categoryId: '' } }).valueChanges.subscribe(result => {
        if (result.loading) return;
        this.loading = false;
        if (result.data?.site?._id) {
          this.siteId = result.data.site._id;
          this.currentSiteData = {
            url: this.siteUrl,
            name: result.data.site.client?.name || '',
            registeredName: result.data.site.client?.registeredName || '',
            registered_number: result.data.site.client?.registered_number || '',
            email: result.data.site.client?.email || '',
            phone: result.data.site.client?.phone || '',
            contact_page: result.data.site.client?.contact_page || '',
            blog_cta: result.data.site.client?.blog_cta || false,
            portal: result.data.site.client?.portal || false,
            contact_form: result.data.site.client?.contact_form ?? true,
            team_modal: result.data.site.client?.team_modal || false,
            team_basic: result.data.site.client?.team_basic ?? true,
            footer_text: result.data.site.client?.footer_text || '',
            bannerTitleWhite: result.data.site.client?.bannerTitleWhite || false,
            gtm: result.data.site.client?.gtm || '',
            logo: result.data.site.client?.logo?.src || '',
            socialImage: result.data.site.client?.socialImage?.src || '',
            favicon: {
              s16: result.data.site.client?.favicon?.s16 || '',
              s32: result.data.site.client?.favicon?.s32 || '',
              s180: result.data.site.client?.favicon?.s180 || '',
              s192: result.data.site.client?.favicon?.s192 || '',
              s512: result.data.site.client?.favicon?.s512 || ''
            },
            contact: {
              line1: result.data.site.client?.contact?.line1 || '',
              line2: result.data.site.client?.contact?.line2 || '',
              city: result.data.site.client?.contact?.city || '',
              county: result.data.site.client?.contact?.county || '',
              postcode: result.data.site.client?.contact?.postcode || '',
              country: result.data.site.client?.contact?.country || ''
            },
            social: {
              facebook: result.data.site.client?.social?.facebook || '',
              instagram: result.data.site.client?.social?.instagram || '',
              linkedIn: result.data.site.client?.social?.linkedIn || '',
              twitter: result.data.site.client?.social?.twitter || ''
            }
          };
        }
      });
  }

  onSuccess(message: string) {
    this.successMessage = message;
    this.errorMessage = '';
    setTimeout(() => this.successMessage = '', 3000);
  }

  onError(message: string) {
    this.errorMessage = message;
    this.successMessage = '';
  }

  
  
}
